<div class="wrapper-timeline">
  <div class="description">
    <img src="assets/images/timeline-delivery-mat.svg" alt="Welcome Materials">
    <p class="heading-1 title">Suivi des commandes</p>
    <p class="caption-2 validation">Retrouvez ici l’évolution pas à pas des commandes et livraisons de vos matériaux.</p>
  </div>
</div>
